































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { routes, getTitleFromRouteName } from '@/router';
import { Prop, Watch } from 'vue-property-decorator';
import { IUser } from '@/models';
import Logo from '@/components/UI/Logo.vue';
import { getValue, setValue } from '../../utils';
import { PREFERENCES } from '../../const';
import { getDarkMode } from '@/plugins/dark';
import { Access } from '@/models';
@Component({
  components: {
    Logo,
  },
})
export default class Header extends Vue {
  @Action('logout', { namespace: 'user' }) logout: () => void;
  dark = getDarkMode();

  @Getter('notifications', { namespace: 'user' }) notifications: object[];
  get routeName() {
    const path = this.$route.path || '';
    return getTitleFromRouteName(this.$route.name || '');
  }
  @Watch('dark')
  onDarkChange(value: boolean) {
    this.$vuetify.theme.dark = value;
    setValue(PREFERENCES.PREFER_DARK_MODE, value);
  }

  @Getter('modules', { namespace: 'user' }) modules: Record<string, string>;
  get routes() {
    return routes;
  }
  get subRoutes() {
    //@ts-ignore
    return routes.find((item) => {
      const rootCheck = item.root.name === this.$route.name;
      const subRoutesCheck =
        [...item.routes, ...item.subRoutes].findIndex(
          ({ name }) => name === this.$route.name,
        ) > -1;
      return rootCheck || subRoutesCheck;
    }).subRoutes;
  }
}
